import storage from 'store'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import {  login,  logout,  getInfo} from '@/api/login'

const user = { 
  state: {
	userid:0,
    token: '',
    name: '',
    avatar: '',
    roles: [],
    info: {},
    superAdmin: false,
    permissions: [],
    noPermissions: false,
	nextlogin:false,
	
	
	menuList:[],
	userInfor:[],
	msgList:[],
  },

  mutations: {
    SET_USERID: (state, userid) => {
      state.userid = userid
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name }) => {
      state.name = name
    },
    SET_USERNAME: (state, { name }) => {
      state.name = name
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_PERMISSION: (state, permissions) => {
      state.permissions = permissions
    },
    SET_NOPERMISSION: (state, flag) => {
      state.noPermissions = flag
    },
    SET_SUPER_ADMIN: (state, superAdmin) => {
      state.superAdmin = superAdmin
    }, 
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
	SET_NextLogin: (state, nextlogin) => {
	   state.nextlogin = nextlogin;
	},
	  
  },

  actions: {
    // 登录
    Login({commit}, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => { 
		  
          if (res.errcode !== 0){
            reject(res.msg)
          }
          storage.set(ACCESS_TOKEN, res.datas.token, 24 * 60 * 60 * 1000)
          commit('SET_TOKEN', res.datas.token)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    Logout({ commit, state },usertoken) {
      return new Promise((resolve,reject) => { 
		//console.log("Logout-token-p:",usertoken);		
        logout(usertoken).then(res => {
			  if(res.errcode!==0)
			  {
				  reject(res.msg)
			  }
			commit('SET_TOKEN', '')
			commit('SET_PERMISSION', [])
			commit('SET_NOPERMISSION', false)
			storage.remove(ACCESS_TOKEN)
			storage.remove("NextLogin");
			storage.remove("userinfor");
			resolve(res)
          })
          .catch((err) => {
            console.log('logout fail:', err)
            // resolve()
          })
          .finally(() => {})
      })
    },
    // 获取用户信息
    GetInfo({ commit,state}) {
      return new Promise((resolve, reject) => {
        getInfo({token:state.token})
          .then((res) => {
            if (res.errcode !== 0) {
              reject(res.msg)
            }
            commit('SET_USERID', res.datas.id)
            commit('SET_NAME', { name: res.datas.name })
            commit('SET_AVATAR', { name: res.datas.avatar })
            commit('SET_INFO', res.datas)
			
			storage.set("userinfor",{id:res.datas.id,name:res.datas.name,avatar:res.datas.avatar})
			console.log("SET_INFO:",res.datas);			
            //commit('SET_NOPERMISSION', res.data.permissions && res.data.permissions.length > 0 ? false : true)
            //commit('SET_SUPER_ADMIN', res.data.superAdmin)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }, 
	SetNextLogin({ commit, state },nextlogin){		
		commit("SET_NextLogin",nextlogin);
		if(nextlogin==true)
		{ 
			storage.set("NextLogin",nextlogin, 24 * 60 * 60 * 1000);
		}
		else{
			storage.remove("NextLogin");
		}
	},

  }
}

export default user